import React from "react";
import AccountLayout from "../layouts/AccountLayout/AccountLayout";
import CampaignDetailContainer from "../features/campaignDetail/containers/CampaignDetailContainer";

const CampaignDetailView = (props) => {
  return (
    <AccountLayout>
      <CampaignDetailContainer {...props} />
    </AccountLayout>
  );
};

export default CampaignDetailView;
